import * as React from "react";
import { RLink } from "./RLink";

export type SimplifiedUser = {
  username: string;
  avatar_url: string;
};

export class AvatarList extends React.Component<
  {
    users: (SimplifiedUser | "Anonymous")[];
    compact?: boolean;
  },
  {}
> {
  render(): JSX.Element {
    const { users, compact } = this.props;

    const makeEntry = (user: SimplifiedUser | "Anonymous", i: number) => {
      let img: React.ReactNode;
      let username: string;

      const imgClass = compact
        ? "inline-block h-8 w-8 rounded-md object-cover"
        : "inline-block h-12 w-12 rounded-lg object-cover";

      if (
        user === "Anonymous" ||
        user.username === "Anonymous Chip" ||
        user.username === "Anonymous"
      ) {
        img = <img src="/img/anonymous-chip.png" className={imgClass} />;
        username = "Anonymous";
      } else {
        img = <img src={user.avatar_url} className={imgClass} />;
        username = user.username;
      }

      if (compact) {
        return (
          <RLink key={username + i} to={"/user/" + username}>
            {img}
          </RLink>
        );
      }

      return (
        <RLink className="block" key={username + i} to={"/user/" + username}>
          {img}
        </RLink>
      );
    };

    // Only show the first user (the person who did the action)
    const firstUser = users[0];
    if (!firstUser) return <div />;

    return <div className={compact ? "" : "w-[60px]"}>{makeEntry(firstUser, 0)}</div>;
  }
}
